module.exports = __webpack_public_path__ + "static/bett1aces-unboxing-small-cfc45f91e091640dfa70bd138e867526.mp4";